var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "truck-summary-modal" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            fullscreen: "",
            title: _vm.$t("planning.dialog.updateRoute"),
            visible: _vm.visibility,
            "before-close": _vm.onDialogClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visibility = $event
            },
          },
        },
        [
          _c(
            "el-row",
            {
              staticStyle: { "margin-bottom": "24px" },
              attrs: { type: "flex", gutter: 20 },
            },
            [
              _c(
                "el-col",
                {
                  staticStyle: { "margin-top": "8px" },
                  attrs: { xs: 24, sm: 24, md: 18 },
                },
                [
                  _vm.routeDetails && _vm.routeDetails["orderId"]
                    ? _c(
                        "el-select",
                        {
                          staticClass: "w-100",
                          attrs: {
                            size: "small",
                            filterable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.deletedOrders,
                            callback: function ($$v) {
                              _vm.deletedOrders = $$v
                            },
                            expression: "deletedOrders",
                          },
                        },
                        _vm._l(_vm.routeDetails["orderId"], function (orderId) {
                          return _c("el-option", {
                            key: orderId,
                            attrs: {
                              label: _vm.getOrderField(
                                orderId,
                                "shipmentReference"
                              ),
                              value: orderId,
                            },
                          })
                        }),
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-col",
                {
                  staticStyle: { "margin-top": "8px" },
                  attrs: { xs: 24, sm: 24, md: 6 },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        size: "small",
                        disabled: !_vm.deletedOrders.length,
                      },
                      on: { click: _vm.removeOrders },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.$t("planning.removeOrders")) + " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.routeForm,
                "label-width": "265px",
                "label-position": "left",
                size: "mini",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { type: "flex", gutter: 20 } },
                [
                  _vm.routeDetails
                    ? _c(
                        "el-col",
                        {
                          staticClass: "order-list",
                          attrs: { xs: 24, sm: 24, md: 8 },
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { type: "flex" } },
                            [
                              _c("el-col", [
                                _c("h5", [
                                  _vm._v(
                                    _vm._s(_vm.$t("planning.tooltip.shipRefs"))
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _c("br"),
                          _vm._l(
                            _vm.getWaypointsFromIds(
                              _vm.routeDetails["waypointId"]
                            ),
                            function (item, index) {
                              return _c(
                                "el-row",
                                {
                                  key: index,
                                  staticClass: "order-container",
                                  attrs: { type: "flex" },
                                },
                                [
                                  _c("el-col", { attrs: { span: 24 } }, [
                                    _c(
                                      "div",
                                      { staticClass: "float-right" },
                                      [
                                        _c(
                                          "el-tooltip",
                                          { attrs: { placement: "top" } },
                                          [
                                            _c(
                                              "div",
                                              {
                                                attrs: { slot: "content" },
                                                slot: "content",
                                              },
                                              [
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.columns.planId"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.routeDetails.planId
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.companyName"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.companyName)
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.gMap.district"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " + _vm._s(item.district)
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.address"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.address1) +
                                                      " "
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.actualFinishDate"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  item.completedTime ===
                                                  "0000-00-00 00:00:00"
                                                    ? _c("span", [
                                                        _vm._v(" - "),
                                                      ])
                                                    : _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm._f(
                                                              "convertTimezone"
                                                            )(
                                                              item.completedTime,
                                                              _vm.$timezone
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                ]),
                                                _c("hr"),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.start"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "convertTimezone"
                                                        )(
                                                          _vm.routeDetails
                                                            .startTime,
                                                          _vm.$timezone
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.eta"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "convertTimezone"
                                                        )(
                                                          _vm.routeDetails
                                                            .estimateTime,
                                                          _vm.$timezone
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                _c("div", [
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "planning.tooltip.end"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm._f(
                                                          "convertTimezone"
                                                        )(
                                                          _vm.routeDetails
                                                            .endTime,
                                                          _vm.$timezone
                                                        )
                                                      )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                            _c("font-awesome-icon", {
                                              attrs: { icon: "info-circle" },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.companyName"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            item["companyName"] !== ""
                                              ? item["companyName"]
                                              : "-"
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.projectCode"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "projectCode"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.customerCode"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "customerCode"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.columns.shipmentReference"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "shipmentReference"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.expectedDate"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.getWaypointEndTime(index))
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.qty")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "quantity"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.gw")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "weight"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.cbm")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "volume"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.serviceType"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "serviceType"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "planning.tooltip.commodityType"
                                            )
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "commodityType"
                                            )
                                          )
                                      ),
                                    ]),
                                    _c("div", [
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("planning.tooltip.remarks")
                                          ) + ":"
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getOrderField(
                                              _vm.getOrderId(index),
                                              "remarks"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { xs: 24, sm: 24, md: 16 } },
                    [
                      _c(
                        "el-row",
                        { attrs: { type: "flex" } },
                        [
                          _c("el-col", [
                            _c("h5", [
                              _vm._v(_vm._s(_vm.$t("planning.timeDetails"))),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _c("br"),
                      _c(
                        "el-row",
                        { attrs: { type: "flex" } },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("planning.dialog.lockRoute"),
                                    prop: "locked",
                                  },
                                },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: _vm.$t(
                                          "planning.tooltip.lockRoute"
                                        ),
                                        placement: "top",
                                      },
                                    },
                                    [
                                      _c("el-checkbox", {
                                        model: {
                                          value: _vm.routeForm.locked,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.routeForm,
                                              "locked",
                                              $$v
                                            )
                                          },
                                          expression: "routeForm.locked",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t("planning.dialog.startTime"),
                                    prop: "startTime",
                                  },
                                },
                                [
                                  _c("el-time-picker", {
                                    attrs: {
                                      clearable: false,
                                      "picker-options": { firstDayOfWeek: 7 },
                                      format: "yyyy-MM-dd HH:mm",
                                    },
                                    model: {
                                      value: _vm.routeForm.convertedStartTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.routeForm,
                                          "convertedStartTime",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "routeForm.convertedStartTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "planning.dialog.waitingTime"
                                    ),
                                    prop: "waitingTime",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: { min: 0, step: 5 },
                                    model: {
                                      value: _vm.routeForm.waitingTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.routeForm,
                                          "waitingTime",
                                          $$v
                                        )
                                      },
                                      expression: "routeForm.waitingTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "planning.dialog.handlingTime"
                                    ),
                                    prop: "handlingTime",
                                  },
                                },
                                [
                                  _c("el-input-number", {
                                    attrs: { min: 0, step: 5 },
                                    model: {
                                      value: _vm.routeForm.handlingTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.routeForm,
                                          "handlingTime",
                                          $$v
                                        )
                                      },
                                      expression: "routeForm.handlingTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.onDialogClose } },
                [_vm._v(_vm._s(_vm.$t("planning.dialog.cancelUpdate")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.updateDetails },
                },
                [_vm._v(_vm._s(_vm.$t("planning.dialog.updateRoute")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }